const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.PRODUCTION_STAGES)

const PRODUCTION_STAGE_CUTTING_TYPES_QUERY_KEY = 'production-stage-cutting-types' as const
const productionStageCuttingTypesQueryKey = { ...useQueryKeyFactory(PRODUCTION_STAGE_CUTTING_TYPES_QUERY_KEY) }

export const apiProductionStage = {
	fetchProductionStageCuttingTypes: async (): Promise<IDietProductionStageCuttingTypeModel[]> => {
		const fetchFn = async () => {
			const { data } = await apiCommon<IDietProductionStageCuttingType[]>(`${groupPrefix}/cutting-types`, {
				method: 'GET',
			})

			return data?.map(DietProductionStageCuttingType) ?? []
		}

		const config = () => ({
			queryKey: productionStageCuttingTypesQueryKey.list(),
			queryFn: async () => await fetchFn(),
		})

		const queryClient = useQueryClient()

		const query = config()

		return (
			queryClient.getQueryData<IDietProductionStageCuttingTypeModel[]>(query.queryKey) ??
			(await queryClient.fetchQuery(query))
		)
	},
}
